<template>
    <div>
        <transition name="popup">
            <div v-if="showPopup" class="popup-overlay" @click.self="closePopup">
                <div class="popup-container">

                    <button class="popup-close" @click="closePopup" aria-label="Закрыть">
                        <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M0.494853 15.703C-0.144973 16.3298 -0.158031 17.4789 0.50791 18.1448C1.17385 18.8108 2.32293 18.7847 2.94969 18.1579L9.00845 12.0991L15.0672 18.1448C15.7201 18.7977 16.8431 18.8108 17.509 18.1318C18.1749 17.4658 18.1749 16.3429 17.5221 15.69L11.4764 9.64428L17.5221 3.58553C18.1749 2.93264 18.1749 1.80968 17.509 1.14374C16.8431 0.464742 15.7201 0.4778 15.0672 1.13068L9.00845 7.17638L2.94969 1.11763C2.32293 0.490858 1.17385 0.464742 0.50791 1.13068C-0.158031 1.79662 -0.144973 2.9457 0.494853 3.58553L6.55361 9.64428L0.494853 15.703Z"
                                fill="#F2E4B5" />
                        </svg>
                    </button>
                    <transition name="fade">
                        <div class="popup-content" v-if="!success && !errorSms">
                            <div>
                                <div class="mb-5">
                                    <p class="otp-title">введите код</p>
                                    <p class="otp-description">На номер был отправлен код, для того чтобы продолжить введите код</p>
                                </div>
                                <div class="ma-auto position-relative" style="max-width: 300px">
                                    <v-otp-input v-model="otp" length="4" :disabled="loading" type="tel"></v-otp-input>
                                    <v-overlay absolute :value="loading">
                                        <v-progress-circular indeterminate color="primary"></v-progress-circular>
                                    </v-overlay>
                                </div>

                                <div v-if="errorMessage" class="mt-2">
                                    <p class="code-error">{{ errorMessage || 'код введен неверно' }}</p>
                                </div>

                                <div class="sms-timer mt-4">
                                    <p v-if="smsTimer > 0">Повторно отправить SMS можно через {{ smsTimer }} сек.</p>
                                    <button v-else @click="$emit('resend')" class="resend-btn">Повторно отправить SMS</button>
                                </div>

                                <div class="btn-container-success">
                                    <button class="btn-success" @click="confirmOtp" :disabled="loading">
                                        {{ loading ? 'Отправка...' : 'Подтвердить' }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </transition>
                    <transition name="fade">
                        <div class="popup-content-success" v-if="success">
                            <p class="otp-success-text">Регистрация пройдена успешно</p>
                        </div>
                        <div class="popup-content-error" v-if="errorSms">
                            <p class="otp-success-error mb-3">Вы уже зарегистрированы</p>
                            <p class="otp-success-error">Повторная регистрация невозможна</p>
                        </div>
                    </transition>

                </div>
            </div>
        </transition>
    </div>
</template>

<style scoped>
.popup-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 18, 12, 0.78);
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
    z-index: 2500;
    box-sizing: border-box;
}

.popup-container {
    background: radial-gradient(130% 120% at 50% 0%, #0d402c 0%, #082d1f 48%, #031a12 100%);
    border: 1px solid rgba(242, 228, 181, 0.28);
    border-radius: 28px;
    box-shadow: 0 24px 60px rgba(0, 0, 0, 0.6), inset 0 1px 0 rgba(255, 248, 229, 0.18);
    padding: 44px 36px 40px;
    text-align: center;
    position: relative;
    width: 100%;
    max-width: 540px;
    min-height: 480px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    overflow: hidden;
}

.popup-close {
    position: absolute;
    top: 20px;
    right: 20px;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: rgba(242, 228, 181, 0.08);
    border: 1px solid rgba(242, 228, 181, 0.2);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #f2e4b5;
    cursor: pointer;
    z-index: 10;
    transition: all 0.25s ease;
    outline: none;
    padding: 0;
}

.popup-close:hover {
    background: rgba(242, 228, 181, 0.2);
    border-color: rgba(242, 228, 181, 0.4);
    transform: rotate(90deg) scale(1.05);
}

.popup-content {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 10px 0;
}

.popup-content > div {
    width: 100%;
}

.popup-content-success,
.popup-content-error {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-height: 360px;
    width: 100%;
    text-align: center;
    padding: 20px;
    box-sizing: border-box;
}

.otp-title {
    font-family: "JJ", "jj2bold", "OswaldBold", sans-serif;
    font-weight: 700;
    font-size: 34px;
    line-height: 1.15;
    color: #F2E4B5;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    margin-bottom: 12px;
}

.otp-description {
    font-family: "JJ", "jj2book", "HelveticaNeueCyr", sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 1.45;
    color: rgba(242, 228, 181, 0.88);
    max-width: 400px;
    margin: 0 auto;
}

.otp-success-text {
    font-family: "JJ", "jj2bold", "OswaldBold", sans-serif;
    font-weight: 700;
    font-size: 34px;
    line-height: 1.25;
    color: #F2E4B5;
    text-transform: uppercase;
    letter-spacing: 0.03em;
    margin-bottom: 0px;
    max-width: 380px;
}

.otp-success-error {
    font-family: "JJ", "jj2bold", "OswaldBold", sans-serif;
    font-weight: 700;
    font-size: 28px;
    line-height: 1.25;
    color: #FFF8E5;
    text-transform: uppercase;
    letter-spacing: 0.03em;
    margin-bottom: 0px;
    max-width: 400px;
}

.position-relative {
    position: relative;
}

::v-deep .v-otp-input {
    justify-content: center;
}

::v-deep .v-otp-input .v-input {
    margin: 0 4px;
    max-width: 62px;
}

::v-deep .v-text-field--outlined > .v-input__control > .v-input__slot {
    align-items: stretch;
    min-height: 72px;
    background: #F2E4B5 !important;
    border: 2px solid transparent !important;
    border-radius: 14px !important;
    box-shadow: inset 0 2px 5px rgba(0, 0, 0, 0.12);
    transition: all 0.2s ease;
}

::v-deep .v-text-field--outlined.v-input--is-focused > .v-input__control > .v-input__slot {
    border-color: #C6A15B !important;
    box-shadow: 0 0 0 3px rgba(198, 161, 91, 0.35), inset 0 2px 4px rgba(0, 0, 0, 0.1);
}

::v-deep .theme--light.v-otp-input .v-input .v-input__control .v-input__slot {
    background: #F2E4B5 !important;
}

::v-deep .v-otp-input input {
    text-align: center;
    font-family: "JJ", "jj2bold", "OswaldBold", sans-serif;
    font-size: 28px;
    font-weight: 700;
    color: #002820 !important;
    caret-color: #00483A;
}

.code-error {
    color: #FF6666;
    font-family: "JJ", "jj2bold", sans-serif;
    font-size: 15px;
    line-height: 1.3;
    margin-bottom: 0;
    text-align: center;
    background: rgba(255, 70, 70, 0.12);
    border: 1px solid rgba(255, 70, 70, 0.35);
    border-radius: 8px;
    padding: 6px 14px;
    display: inline-block;
}

.sms-timer {
    font-family: "JJ", "jj2book", sans-serif;
    font-size: 15px;
    color: rgba(242, 228, 181, 0.78);
    margin-top: 18px;
}

.sms-timer p {
    margin-bottom: 0;
}

.sms-timer .resend-btn {
    font-family: "JJ", "jj2bold", sans-serif;
    text-decoration: underline;
    text-underline-offset: 3px;
    color: #F2E4B5;
    font-size: 15px;
    font-weight: 700;
    cursor: pointer;
    background: none;
    border: none;
    padding: 0;
    transition: color 0.2s, opacity 0.2s;
}

.sms-timer .resend-btn:hover {
    opacity: 0.82;
    color: #FFF8E5;
}

.btn-container-success {
    margin-top: 32px;
}

.btn-success {
    display: inline-block;
    border-radius: 12px;
    padding: 13px 44px;
    height: 56px;
    min-width: 220px;
    background: #007749;
    font-family: "JJ", "jj2bold", "OswaldBold", sans-serif;
    font-weight: 700;
    font-size: 18px;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: #F2E4B5;
    cursor: pointer;
    border: 1px solid rgba(242, 228, 181, 0.25);
    box-shadow: 0 4px 0 #005032, 0 8px 20px rgba(0, 0, 0, 0.25);
    transition: all 0.2s ease;
}

.btn-success:hover:not(:disabled) {
    background: #008753;
    transform: translateY(-2px);
    box-shadow: 0 6px 0 #005032, 0 12px 24px rgba(0, 0, 0, 0.3);
}

.btn-success:active:not(:disabled) {
    background: #007749;
    transform: translateY(2px);
    box-shadow: 0 2px 0 #005032, 0 4px 10px rgba(0, 0, 0, 0.2);
}

.btn-success:disabled {
    opacity: 0.65;
    cursor: not-allowed;
    box-shadow: none;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.35s ease;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.popup-enter-active,
.popup-leave-active {
    animation: fadeIn 0.3s ease-in-out, slideIn 0.3s ease-in-out;
}

.popup-leave-active {
    animation: fadeOut 0.3s ease-in-out, slideOut 0.3s ease-in-out;
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

@keyframes fadeOut {
    from {
        opacity: 1;
    }
    to {
        opacity: 0;
    }
}

@keyframes slideIn {
    from {
        transform: translateY(-18px) scale(0.97);
        opacity: 0;
    }
    to {
        transform: translateY(0) scale(1);
        opacity: 1;
    }
}

@keyframes slideOut {
    from {
        transform: translateY(0) scale(1);
        opacity: 1;
    }
    to {
        transform: translateY(-18px) scale(0.97);
        opacity: 0;
    }
}

@media (min-width: 567px) and (max-width: 1024px) {
    .popup-container {
        max-width: 500px;
        min-height: 440px;
        padding: 40px 30px;
    }

    .btn-container-success {
        margin-top: 24px;
    }
}

@media screen and (max-width: 566px) {
    .popup-overlay {
        padding: 14px;
    }

    .popup-container {
        padding: 36px 20px 28px;
        border-radius: 20px;
        min-height: auto;
        max-width: 100%;
    }

    .popup-close {
        top: 14px;
        right: 14px;
        width: 34px;
        height: 34px;
    }

    .otp-title {
        font-size: 24px;
        margin-bottom: 8px;
    }

    .otp-description {
        font-size: 14px;
        line-height: 1.4;
    }

    .otp-success-text {
        font-size: 26px;
    }

    .otp-success-error {
        font-size: 22px;
    }

    .popup-content-error {
        padding: 10px 0;
        min-height: auto;
    }

    .position-relative {
        max-width: 280px !important;
    }

    ::v-deep .v-text-field--outlined > .v-input__control > .v-input__slot {
        min-height: 62px;
        border-radius: 10px !important;
    }

    ::v-deep .v-otp-input input {
        font-size: 22px;
        color: #002820 !important;
    }

    .sms-timer {
        font-size: 14px;
    }

    .sms-timer .resend-btn {
        font-size: 14px;
    }

    .btn-container-success {
        margin-top: 24px;
    }

    .btn-success {
        width: 100%;
        max-width: 280px;
        height: 50px;
        font-size: 16px;
        padding: 10px 24px;
    }
}
</style>

<script>
export default {
    name: "otp",
    props: {
        showPopup: {
            type: Boolean,
            default: false,
        },
        smsTimer: {
            type: Number,
            default: 0
        },
        success: {
            type: Boolean,
            default: false,
        },
        errorMessage: {
            type: String,
            default: ""
        },
        errorSms: {
            type: Boolean,
            default: false
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            otp: '',
            expectedOtp: '1111',
            isSuccess: false,
        };
    },
    methods: {
        confirmOtp() {
            this.$emit('verifyCode', this.otp);
        },
        closePopup() {
            this.$emit('closePopup');
            this.otp = '';
        }
    },
    watch: {
        showPopup() {
            this.otp = '';
        },
        success(val) {
            if (val) {
                this.otp = '';
            }
        },
        errorMessage(val) {
            if (val) {
                this.otp = '';
            }
        }
    },
    mounted() {}
}
</script>